import React from 'react'
import logo from '../../images/LinehaulIco.png'

const Spinner = ({show}) => {
  return (
    <div className={show?"loading d-block":"loading"}><img src={logo} alt="Loading..."/></div>
  )
}

export default Spinner